/**
 * ENUM
 * 
 *
 * @author Kiara Martins
 */
export const QuestionAnswerEnum = {
    CORRECT: 'Correta',
    INCORRECT: 'Incorreta',
    OPEN_ANSWER: 'Aguardando'
}


// WEBPACK FOOTER //
// ./src/enums/QuestionAnswerEnum.js